var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 311,
    viewBox: "0 0 313 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 248.24C46.86 253.137 119.049 232.132 146.97 175.287C181.872 104.231 100.925 132.943 123.659 164.848C146.394 196.753 253.837 164.848 272.431 70.7218",
    stroke: "#217781",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1767_137650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.894 26.1007L277.033 26.2395C277.088 26.311 277.135 26.3886 277.172 26.4709L296.65 65.4121C296.748 65.6156 296.786 65.8429 296.758 66.067C296.731 66.2911 296.64 66.5027 296.496 66.6767L296.435 66.7384C296.289 66.8869 296.105 66.9916 295.904 67.0407C295.702 67.0898 295.49 67.0812 295.293 67.016L275.8 61.1861C275.563 61.1137 275.357 60.9661 275.212 60.7656C275.067 60.5652 274.992 60.3229 274.998 60.0757L274.997 31.8224L258.928 63.9619L267.996 60.9393C268.138 60.8916 268.287 60.8725 268.437 60.8832C268.586 60.8939 268.731 60.9342 268.865 61.0016C268.998 61.0691 269.117 61.1624 269.214 61.2761C269.311 61.3898 269.385 61.5217 269.43 61.6641C269.479 61.8079 269.499 61.9599 269.489 62.1114C269.479 62.2629 269.439 62.4109 269.372 62.547C269.304 62.683 269.211 62.8045 269.096 62.9044C268.982 63.0043 268.849 63.0807 268.705 63.1292L257.016 67.0154C256.803 67.0876 256.574 67.0954 256.357 67.0378C256.141 66.9801 255.946 66.8597 255.797 66.6915C255.648 66.5175 255.553 66.3039 255.523 66.0767C255.492 65.8494 255.529 65.6184 255.627 65.4115L275.105 26.4709C275.151 26.3938 275.198 26.3167 275.259 26.2241L275.383 26.1008C275.596 25.9231 275.861 25.8202 276.138 25.8077L276.154 25.8231C276.425 25.8258 276.687 25.9241 276.894 26.1007Z",
    fill: "#217781"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1767_137650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5744,
    height: 43.5744,
    fill: "white",
    transform: "matrix(0.706346 -0.707867 0.706346 0.707867 244.219 56.1895)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalArrow);
export default __webpack_public_path__ + "static/media/verticalArrow.c6706e5c0ccccd887bcd0529b61a3a96.svg";
export { ForwardRef as ReactComponent };